/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ProductCodeValue} from './ProductCodeValue';
import {Certificate} from './Certificate';
import {CommercePrice} from './CommercePrice';
import {Marker} from './Marker';
import {DocumentLink} from './DocumentLink';
import {AvailabilityType} from './AvailabilityType';
import {ShowcaseDocumentItem} from './ShowcaseDocumentGroup';
import {ShowcaseLinkedGood} from './ShowcaseLinkedGood';
import {YouTube} from './YouTube';

export type BalancesOnGroupsOfWarehouses = Record<number, number>;

export type AvailabilityOnGroupsOfWarehouses = Record<number, AvailabilityType>;

export type ProductPicturesSource = 'DEFAULT' | 'DAM';

export interface ProductCustomer {
  id: number;
  header: string;
  barCode?: string;
  articul?: string;
  syncUid: string;
  content?: string;
  description?: string;
  price?: number;
  commercePrice?: CommercePrice;
  width?: number;
  height?: number;
  length?: number;
  weight?: number;
  productStatusId?: number;
  unitHeader?: string;
  terms?: string[];
  picture?: string;
  pictures?: string[];
  picturesSource?: ProductPicturesSource;
  manufacturerHeader?: string;
  brandHeader?: string;
  manufacturerSeriesHeader?: string;
  manufacturerSiteLink?: string;
  features?: any;
  codes?: ProductCodeValue[];
  videos?: YouTube[];
  categoryHeader?: string;
  /** Имя «лучшего видимого каталога» товара в скоупе витрины (резолв product→best-visible-catalog,
   *  консистентно с крошками PDP). Колонка «Каталог» table-view листинга витрины. */
  catalogHeader?: string;
  /** Id того самого best-visible каталога — для клика в каталог (`?catalog_id=<id>`); null вместе с
   *  catalogHeader у «висячих» товаров без видимого на витрине каталога. */
  catalogHeaderCatalogId?: number;
  analogList?: ProductCustomer[];
  relatedList?: ProductCustomer[];
  certificateList?: Certificate[];
  documents?: ShowcaseDocumentItem[];
  linkedGoods?: ShowcaseLinkedGood[];
  importKey?: string;
  // stocks?: Stock[];
  flatCodes?: Map<string, string>;
  balancesOnGroupsOfWarehouses?: BalancesOnGroupsOfWarehouses;
  availabilityOnGroupsOfWarehouses?: AvailabilityOnGroupsOfWarehouses;
  multiplicityOrder?: number;
  multiplicitySupplier?: number;
  markers: Marker[];
  supplyTerm: number;
  documentList?: DocumentLink[];
  htHead: string;
  htDesc: string;
  htKeywords: string;
  url: string;
  analogCount?: number;
  relatedCount?: number;
  discountPrice?: number;
  discountCostOnlyTotal?: number;
}
